import React from "react";
import PropTypes from "prop-types";

export default function TagsMenuHint({ children, css, ...props }) {
  return (
    <div
      css={{
        padding: 7,
        ...css,
      }}
      {...props}
    >
      {children}
    </div>
  );
}

TagsMenuHint.propTypes = {
  children: PropTypes.any,
  css: PropTypes.object,
};

TagsMenuHint.defaultProps = {
  children: null,
  css: {},
};
